<template>
	<div class="my-gift">
		<Tab ref="tab" :tabData="tabData" @tab-click="handleChangeTab" />

		<div class="scroller">
			<nut-scroller
				:is-un-more="isUnMore"
				:is-loading="isLoading"
				:type="'vertical'"
				@loadMore="loadMoreVert"
				@pulldown="pulldown"
			>
				<div slot="list">
					<template v-if="listData && listData.length">
					<div class="nut-vert-list-item" v-for="(item, index) in listData" :key="index">
						<ul class="nut-scroller-item-info " :class="{ isExpened: !item.expended }">
							<li class="flex a-center" style="margin-bottom: 10px">
								<span class="flex-g-1 flex a-center">
									<b class="name">{{item.wheelname}}</b>
									<span class="tag" v-if="item.lottey_state > 0 && item.cashtime == 0 && item.receive_etime > allData.time">未兑奖</span>
									<span class="tag disabled" v-else-if="item.lottey_state > 0 && item.cashtime !== '0'">已兑奖</span>
									<span class="tag disabled" v-else>已过期</span>
								</span>
								<nut-button class="view-button" shape="circle" v-if="item.lottey_state > 0 && item.cashtime == 0 && item.receive_etime > allData.time" @click="redeem(item)">
									查看兑奖码
								</nut-button>
							</li>
							<li>{{item.lottey_state}}等奖：{{item.prizename}}</li>
							<li>兑奖码：{{item.active_code}}</li>
							<li>兑奖截止时间：{{ item.receive_etime | dateformat }}</li>
							<li>兑奖商家：{{item.store_name}}</li>
							<li class="flex j-between">
								<span>联系方式：{{item.store_phone}}</span>
								<a :href="'tel://' + 10086"
									><img
										src="../../assets/images/telphone-icon.png"
										width="12"
										height="12"
								/></a>
							</li>
							<li class="flex j-between">
								<span>商家地址：{{item.store_address}}</span
								><img
									src="../../assets/images/weizhi.png"
									width="11"
									height="13"
								/>
							</li>
						</ul>
						<a
							href="javascript:;"
							class="expand-btn"
							:class="item.expended ? 'hide' : 'open'"
                            @click="handleExpanded(index)"
							>{{ item.expended ? '收起' : '展开'}}<nut-icon type="down" size="10px"></nut-icon
						></a>
						<!-- <a href="javascript:;" class="expand-btn open">展开<nut-icon type="down" size="10px"></nut-icon></a> -->
					</div>
					</template>
					<empty v-else></empty>
				</div>
			</nut-scroller>
		</div>
		<nut-popup :style="{padding:'20px 20px'}" v-model="popupShow" @close="popupClose"><img :src="url" alt=""></nut-popup>
	</div>
</template>

<script>
import empty from '../Empty'
import dayjs from 'dayjs'
var timerJump;
export default {
	components:{empty,},
	name: 'my-gift',
	data: () => ({
		tabData: [
			{ label: '未使用', value: 1 },
			{ label: '已使用', value: 2 },
			{ label: '已过期', value: 3 },
		],
		current: 1,
		isUnMore: false,
		isLoading: false,
		page: 1,
		pageSize: 15,
		listData: [],
		allData:[],
		popupShow:false,
		url:'',
	}),
	created() {
		this.getList();
	},
	mounted() {

      window.document.title='兑奖中心';
      setTimeout(()=>{
        window.document.title='兑奖中心';
      },1500);
      setTimeout(()=>{
        window.document.title='兑奖中心';
      },3000);

	},
	filters: {
		dateformat(value) {
			return dayjs(parseInt(value+'000')).format('YYYY-MM-DD HH:mm:ss')
		},
	},
	methods: {
		getList(){
			this.$ajax.get('m/activebigwheel/ajax_fy', {
				pageIndex: this.page,
				pageSize: this.pageSize,
				id: this.$ajax.get_activity_id(),
				type:this.current,
			}).then(res => {
				this.isLoading = false;
				if (res.list && res.list.length) {
					this.listData = res.list;
					this.listData = this.listData.map((item) => ({ ...item, expended: false }))
					this.allData = res;
					//this.listData.push(res.order_list);
					this.isUnMore = false;
					this.pageSize = 10;
					this.page++;
				} else {
					this.isUnMore = true;
				}
			})
		},
		redeem(item){
			this.url = item.redeem_url;
			this.popupShow = true;
			this.getOrder(item);
		},
		getOrder(item) {
			if (timerJump) {
				clearTimeout(timerJump)
			}
			//奖品兑奖信息获取
			this.$ajax.get('m/activebigwheel/getclaim_state?sn=' + item.active_code, {}).then(reqData => {
				//奖品已兑奖
				if(parseInt(reqData.type) == 1){
					this.$toast.text('兑奖成功')
					clearTimeout(timerJump)
					setTimeout(()=>{
						window.location.reload();
					},2000)
				}

				timerJump = setTimeout(() => {
					this.$ajax.closeLoading();
					this.getOrder(item);
				}, 3000)

			})
		},
		popupClose(){
			clearTimeout(timerJump)
		},
        // 展开/收起
        handleExpanded(index) {
            this.listData[index].expended = !this.listData[index].expended
        },
		handleChangeTab(index) {
			this.listData = [];
			this.current = index
		},

		// 上拉加载更多
		loadMoreVert() {
			this.isLoading = true
			this.getList()
		},
		// 下拉加载更多
		pulldown() {
			this.isLoading = true
			this.pageSize = 15
			this.page = 1
			this.getList()
		},
	},
}
</script>

<style lang="less" scoped>
.my-gift {
	height: 100vh;
}
.scroller {
	height: calc(100% - 40px);
}
.nut-vert-list-item {
	padding: 10px 14px;
	font-size: 13px;
	color: #666666;
	border-bottom: 1px solid #fafafa;
	.name {
		font-size: 15px;
		color: #333333;
	}
	.tag {
		display: inline-block;
		width: 46px;
		height: 20px;
		line-height: 20px;
		background: rgba(252, 232, 234, 1);
		font-size: 11px;
		text-align: center;
		color: #eb273b;
		margin-left: 5px;
		border-radius: 3px;
	}
	.tag.disabled {
		color: #666666;
		background-color: #f0f0f0;
	}
}
.view-button {
	width: 80px;
	height: 28px;
	line-height: 28px;
	padding: 0;
	color: #3c43ec;
	background: transparent;
	border: 1px solid #3c43ec;
}
.nut-scroller-item-info li {
	margin: 5px 0;
}
.expand-btn {
	display: flex;
	align-content: center;
	justify-content: center;
	font-size: 14px;
	color: #666666;
	padding: 5px 0;
	text-align: center;
	.nut-icon {
		margin-top: 0.35em;
		margin-left: 0.2em;
	}
}
.expand-btn.hide {
	.nut-icon {
		transform: rotate(180deg);
	}
}
.isExpened {
	height: 110px;
	overflow: hidden;
}
</style>
